import { OAuthStepHeader } from "../../OAuthStepHeader";
import { OAuthStep } from "../../oauthStep";

import { SkeletonOAuthBankingForm } from "./OAuthBankingForm";

import * as styles from "./OAuthBankingInformation.styles";

const SkeletonOAuthBankingInformation = () => {
  return (
    <div css={styles.main}>
      <OAuthStepHeader currentStep={OAuthStep.PAYMENT} />
      <SkeletonOAuthBankingForm />
    </div>
  );
};

export { SkeletonOAuthBankingInformation };
